import { render, staticRenderFns } from "./visitwebsite.vue?vue&type=template&id=3920725a&"
import script from "./visitwebsite.vue?vue&type=script&lang=js&"
export * from "./visitwebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3920725a')) {
      api.createRecord('3920725a', component.options)
    } else {
      api.reload('3920725a', component.options)
    }
    module.hot.accept("./visitwebsite.vue?vue&type=template&id=3920725a&", function () {
      api.rerender('3920725a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/visitwebsite.vue"
export default component.exports